'use client';

import { FC, useEffect, useRef } from 'react';
import { getWindowTrackerState, setWindowTrackerState, logger } from '../utils';
import { internalTrackEvent, trackPageView } from '../core';
import { useIsTrackerReady } from '../hooks';
import { usePathname } from 'next/navigation';
export const TrackerQueue: FC = () => {
  let ready = useIsTrackerReady();
  let executedForPathname = useRef<string | undefined>(undefined);
  let pathname = usePathname() ?? undefined;
  useEffect(() => {
    if (!ready || executedForPathname.current === pathname) {
      return;
    }
    executedForPathname.current = pathname;
    executeQueues({
      pathname
    });
  }, [ready, pathname]);
  return null;
};
const executeQueues = (ctx: {
  pathname?: string;
}) => {
  let {
    pageViewQueue,
    eventQueue
  } = getWindowTrackerState();
  logger.log(`Executing tracking queues in context of "${ctx.pathname}": ${pageViewQueue.length} page views in queue. ${eventQueue.length} events in queue.`);
  setWindowTrackerState({
    pageViewQueue: [],
    eventQueue: []
  });
  pageViewQueue.forEach(data => trackPageView(data));
  eventQueue.forEach(({
    data,
    resolve,
    reject
  }) => internalTrackEvent(data, resolve, reject));
};